/*
 * @Author: gaobin
 * @Date: 2024-10-09 15:50:15
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-06-09 14:35:26
 * @Description: 自定义存储名称
 */
export const CUR_LANGUAGE = 'custom-app-language';
export const CUR_TOKEN = 'custom_app_token';
export const CUR_USERINFO = 'custom-app-userInfo';
